import { Preloader } from "../components/Preloader/Preloader";

let p=new Preloader();